import { motion } from "framer-motion";

interface StatItem {
  value: string;
  label: string;
}

const StatsRibbon = ({ stats }: { stats: StatItem[] }) => (
  <div className="relative bg-navy-deep border-y border-primary-foreground/5">
    <div className="absolute inset-0 bg-gradient-to-r from-teal/5 via-transparent to-lime/5" />
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 relative">
      <div className="grid grid-cols-2 sm:grid-cols-3 md:flex">
        {stats.map((stat, i) => (
          <motion.div
            key={stat.label}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            viewport={{ once: true }}
            className="flex-1 py-6 md:py-8 text-center border-b border-r border-primary-foreground/5 last:border-r-0 md:border-b-0 md:last:border-r-0"
          >
            <div className="font-display text-2xl md:text-3xl font-bold tracking-tight">
              <span className="accent-text">{stat.value}</span>
            </div>
            <div className="text-primary-foreground/30 font-body text-[10px] tracking-[3px] uppercase mt-2">{stat.label}</div>
          </motion.div>
        ))}
      </div>
    </div>
  </div>
);

export default StatsRibbon;
